import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { cn } from "../../lib/utils";
import { BOROUGH_NAMES } from "../../hooks/useSiteSearch";

export function BoroughSelect({ id, className, onInk = false, value, onValueChange }) {
    return (<Select value={value} onValueChange={onValueChange} className="static">
        <SelectTrigger id={id} aria-label="Borough" className={cn("gap-2 shadow-none focus:ring-foreground/30", className)}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent align="full" sideOffset={6} className={cn( onInk && "border-ink-foreground/20 bg-ink text-ink-foreground")}>
          {BOROUGH_NAMES.map((name) => (<SelectItem key={name} value={name} className={cn("cursor-pointer focus:bg-secondary focus:text-foreground", onInk && "hover:bg-ink-foreground/10 hover:text-ink-foreground focus:bg-ink-foreground/10 focus:text-ink-foreground")}>
              {name}
            </SelectItem>))}
        </SelectContent>
      </Select>);
}
